
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programma",
      function () {
        return require("private-next-pages/programma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programma"])
      });
    }
  